// extracted by mini-css-extract-plugin
export default {"bp-small":"768px","header":"header-module__header___mtu3c","logo":"header-module__logo___qCTOT","fulfillment":"header-module__fulfillment___u4o9p"};